//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import zcitem from "./zcitem"
  import { setTimeout } from 'timers';

  export default {
    name: "record_capital",
    components:{zcitem},
    data(){
      return{
        list:[],
        totals:0,
        page: 0
      }
    },
    created() {
      this.getCapitalList();
    },
    methods:{
        infinite(done) {
            setTimeout (() => {
                if(this.list.length < this.totals){
                    this.page++;
                    this.getCapitalList(done);
                } else {
                    done(true);
                }
            },1000)
        },
        refresh(done) {
            setTimeout(() => {
                this.list = [];
                this.page = 0;
                this.getCapitalList();
                done(true);
            },1000)
        },
        getCapitalList(done) {
            this.$https({
                method: 'post',
                url: this.BASE_URL+'cfs/zc/project/getHelpRecordList',
                data: {
                    pageIndex:this.page ,
                    pageSize: 5,
                    acr026:this.G("zcuserid"),
                },
            }).then(res => {

                if(res.data.data!= null){
                    this.list = [...this.list, ...res.data.data.data];
                    this.totals = res.data.data.total;
                    if(done) {
                        done(true);
                    }
                }else{
                    this.list = [...this.list, ...[]];
                    if(done) {
                        done(true);
                    }
                }

            }).catch(err => {
                this.showToast('','text',err.msg,'20em','','middle');
            })
        },
    }
  }



// WEBPACK FOOTER //
// ./src/crowd_fund/myhelprecord.vue